$(document).ready(function () {
  if (window.header) {
    return;
  }

  function isTabletDevice() {
    return window.innerWidth > 500 && window.innerWidth <= 1024
  }

  function isMobileDevice() {
    return window.innerWidth <= 500;
  }

  const subscriptionRouteInLocal = window.i18next.t('routes.car_subscription.index');
  const isSubscriptionPage = window.location.pathname.includes('subscription') || window.location.pathname.includes(subscriptionRouteInLocal);
  if (isMobileDevice()) {
    $(".menu__submenu-item > .menu__submenu-link[href*='"+ subscriptionRouteInLocal +"#'], .menu__item > .menu__link[href*='"+ subscriptionRouteInLocal +"#']").click(function () {
      $("body").css("overflow", "hidden");
      $("#mobile-menu").toggleClass("show");
      $(".menu-bg-overlay").toggleClass("show");
      $(".menu__sidebar ul li:has(ul.active)").find("ul").hide().removeClass('active');
    });
  }

  $("#burger-menu, #close-nav, .menu-bg-overlay, #burger-menu2").click(function () {
    $("body").css("overflow", "hidden");
    $("#mobile-menu").toggleClass("show");
    $(".menu-bg-overlay").toggleClass("show");
    $(".menu__sidebar ul li:has(ul.active)").find("ul").hide().removeClass('active');
    $('.menu__container > .menu__links').remove()
  });

  $('#close-nav, .menu-bg-overlay').click(function () {
    $("body").css("overflow", "");
  });

  const isCarSearchPage = $('body').hasClass('car-search-page');
  if (isTabletDevice() || isMobileDevice() || isCarSearchPage) {
    $('.menu__sidebar').attr('id', 'mobile-menu')
      .removeClass('desktop-menu');

    $(".menu__sidebar .menu__links li.menu__item.menu__item-dropdown-menu a.menu__link").prop('href', 'javascript:void(0)');

    $(".menu__sidebar ul li:has(ul)").click(function () {
      if ($(this).find("ul").hasClass('active')) {
        $(this).find("ul").hide().removeClass('active');
      } else {
        $(".menu__sidebar ul li:has(ul)").not(this).find("ul").hide().removeClass('active');
        $(this).find("ul").show().addClass('active');
      }
    });

    $('.menu__language-switcher-menu').hide();

    const authLi = $('#my-account-authorized-menu');
    if (authLi) {
      authLi.parent().addClass('menu__item-dropdown-menu');
    }

  } else {
    $('.menu__sidebar').attr('id', null)
      .addClass('desktop-menu')
      .removeClass('menu__sidebar');

    $(".desktop-menu ul li ul").hide();
    $(".desktop-menu ul li:has(ul)").hover(function () {
      $(this).find("ul").show();
    }, function () {
      $(this).find("ul").hide();
    });
    $('.menu__language-switcher-link span').hide();

  }

  var body2 = document.body;
  window.addEventListener("scroll", function () {
    if (window.scrollY > 0) {
      body2.classList.add("scrolled");
    } else {
      body2.classList.remove("scrolled");
    }
  });

  if (isCarSearchPage && !(isTabletDevice() || isMobileDevice())) {
    $(".menu__language-switcher-item ul").hide();
    $(".menu__language-switcher-item").hover(function () {
      $(this).find("ul").show();
    }, function () {
      $(this).find("ul").hide();
    });

    $("#burger-menu").click(function () {
      $('.menu__links').clone().insertAfter('.search-bar').css('width', 'auto').addClass(isSubscriptionPage ? 'px-6 pt-0' : 'px-6 pt-6');
      $('.menu__container > .menu__links > li').not('.menu__language-switcher-item').remove()
    });
  }

  window.header = true;
});
